// packages/components/src/doctor-ai/OverviewTab.tsx
import React from 'react';
import { DiagnosisSummaryCard } from './DiagnosisSummaryCard';
import type { UIChatMessage } from '@dopomogai/types';
import { MessageSquareWarning } from 'lucide-react';

interface OverviewTabProps {
  chatHistory: UIChatMessage[];
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ chatHistory }) => {
  // Find the most recent diagnosis summary from the chat history
  const lastDiagnosis = [...chatHistory]
    .reverse()
    .find(
      (msg): msg is import('@dopomogai/types').UIToolResponseMessage =>
        msg.type === 'tool_response' && msg.toolName === 'render_diagnosis_summary'
    );

  return (
    <div className="p-6 space-y-4">
      <h3 className="text-xl font-bold text-slate-900">Case Overview</h3>
      {lastDiagnosis ? (
        <DiagnosisSummaryCard data={lastDiagnosis.data} />
      ) : (
        <div className="flex flex-col items-center justify-center text-center p-8 bg-slate-100 rounded-xl border-2 border-dashed border-slate-300">
          <MessageSquareWarning size={40} className="text-slate-400 mb-4" />
          <h4 className="font-semibold text-slate-700">No Summary Available</h4>
          <p className="text-sm text-slate-500 mt-1 max-w-sm">
            Ask the AI to "summarize the case" or "provide a diagnosis" in the chat to generate an overview here.
          </p>
        </div>
      )}
    </div>
  );
};